export default __webpack_public_path__ + "static/media/github.387cc16c.svg";